import { Heading, HStack, Spread, VStack } from '@/components/Atoms'
import { Button, Separator } from '@repo/ui/components'
import { cn } from '@repo/ui/lib/utils'
import { Undo2Icon } from 'lucide-react'
import { useTranslation } from 'react-i18next'

type ContainerProps = {
  title: string
  children: React.ReactNode
  isResetVisible?: boolean
  hasOptionsSelected?: boolean
  onReset: () => void
  className?: string
  /** Drops the leading separator, for a form whose fields sit flush with the section (e.g. a dialog). */
  hideSeparator?: boolean
}

export function Container(props: ContainerProps) {
  const { t } = useTranslation('common')

  return (
    <HStack gap="md" align="start" className={cn('w-full min-w-0 max-w-full', props.className)}>
      {!props.hideSeparator && (
        <Separator
          orientation="vertical"
          decorative
          className={cn(
            'h-auto self-stretch transition-colors duration-500',
            props.hasOptionsSelected ? 'bg-primary' : 'bg-border',
          )}
        />
      )}

      <VStack gap="sm" align="start" className="w-full min-w-0">
        <Spread align="center" className="w-full">
          <Heading level={4} className="leading-none">
            {props.title}
          </Heading>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className={cn(
              'transition-opacity',
              props.isResetVisible ? 'opacity-100' : 'pointer-events-none opacity-0',
            )}
            onClick={props.onReset}
          >
            <Undo2Icon />
            {t('actions.reset')}
          </Button>
        </Spread>

        {props.children}
      </VStack>
    </HStack>
  )
}
